import {createSelector, MemoizedSelector} from '@ngrx/store';
import {CustomTicketsListState, StateWithTickets} from '../custom-tickets-state';
import {getTicketstListState} from './feature-selector';

import { StateUtils } from '@spartacus/core';

export const getAllTicketsListState: MemoizedSelector<
  StateWithTickets,
  StateUtils.LoaderState<CustomTicketsListState>
> = createSelector(
  getTicketstListState,
  (state: CustomTicketsListState) => state.entities
);


export const getTickets: MemoizedSelector<
  StateWithTickets,
  CustomTicketsListState
  > = createSelector(
  getAllTicketsListState,
  (state: StateUtils.LoaderState<CustomTicketsListState>) =>
    StateUtils.loaderValueSelector(state)
);

export const getTicketsLoading: MemoizedSelector<
  StateWithTickets,
  boolean
  > = createSelector(
  getAllTicketsListState,
  (state: StateUtils.LoaderState<CustomTicketsListState>) =>
    StateUtils.loaderLoadingSelector(state)
);
